import { FOOTBALL_TYPES, REPORT_TYPES } from "shared/constants";

export const getReportTypeOptions = () => {
  const options = Object.values(REPORT_TYPES)?.map((n) => ({ label: n, value: n }));
  return options || [];
};

export const getFootballTypeOptions = () => {
  const options = Object.values(FOOTBALL_TYPES)?.map((n) => ({ label: n, value: n }));
  return options || [];
};

export const getClubOptions = (clubs) => {
  return clubs.map((club) => ({
    clubId: club.id,
    label: club.name,
    value: club.name,
  }));
};

export const getFixtureOptions = (fixtures) => {
  return fixtures?.map((fixture) => {
    const updatedName = fixture.name.includes("United of Manchester") ? fixture.name.replace("United of Manchester", "FC United of Manchester") : fixture.name;

    return {
      fixtureId: fixture.id,
      label: updatedName,
      value: updatedName,
    };
  });
};

export const getSeasonsOptions = (list) => {
  if (!list) return [];

  const options = list?.map((n) => ({ label: n?.name, value: n?.name }));
  return options;
};

export const getCompetitionListFromSeason = (list, season) => {
  if (!list || !season) return [];

  const selectedSeason = list?.find((item) => item?.name === season);
  const competitions = selectedSeason?.competitions || [];
  const options = competitions?.map((n) => ({ label: n?.name, value: n?.name }));
  return options;
};

export const getAllCompetitionsFromSeasons = (list, removePrefix = false) => {
  if (!list) return [];

  const competitions = list?.map((season) => season?.competitions?.map((n) => n?.name) || []);
  const flatCompetitions = competitions.flat();

  // Process competitions based on removePrefix parameter
  const processedCompetitions = removePrefix
    ? flatCompetitions.map((name) => {
        // Remove "Enterprise " prefix if it exists (including the space after it)
        if (name?.startsWith("Enterprise ")) {
          return name.replace("Enterprise ", "");
        }

        if (name?.endsWith("Premier")) {
          return name.replace("Premier", "").trim();
        }
        return name;
      })
    : flatCompetitions;

  // Get unique competition names
  const options = [...new Set(processedCompetitions)];

  return options?.map((n) => ({ label: n, value: n }));
};
export const getClubsListFromCompetition = (list, season, competition) => {
  if (!list || !season || !competition) return [];

  const selectedSeason = list?.find((item) => item?.name === season);
  const competitions = selectedSeason?.competitions || [];
  const selectedCompetition = competitions?.find((item) => item?.name === competition);
  const options = selectedCompetition?.clubs?.map((n) => ({ label: n, value: n }));
  return options;
};

export const getPaginatedReports = ({ sortedList, page, size }) => {
  if (!sortedList) return [];
  const index = size * page;
  return sortedList?.slice(index, index + size);
};

export const getReportTypeTitle = (report) => {
  switch (report?.report_type?.toLowerCase()) {
    case REPORT_TYPES.FOOTBALL.toLowerCase():
      return `${report?.home_team} - ${report?.away_team}`;
    case REPORT_TYPES.CONCERT.toLowerCase():
      return report?.event_artist;
    default:
      return "-";
  }
};
